import { Link } from "react-router-dom";
import { MapPin, Heart, Eye } from "lucide-react";
import { fileUrl } from "../lib/api";
import { THEMES } from "../lib/constants";
import { Button } from "./ui/button";
import GoalThermometer from "./GoalThermometer";
import VerifiedBadge, { TrustedBadge, UnderWingBadge } from "./VerifiedBadge";

export default function ProfileCard({ profile, onTip }) {
  const theme = THEMES[profile.theme] || THEMES.copper;
  return (
    <div data-testid="profile-card" className="bg-card rounded-2xl border border-border overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col text-center">
      <div className={`h-16 ${theme.cover} relative`}>
        {profile.cover_url && <img src={fileUrl(profile.cover_url)} alt="" className="w-full h-full object-cover" />}
        {profile.protected ? (
          <div className="w-16 h-16 rounded-full border-4 border-card bg-gradient-to-br from-penny/60 to-copper/60 absolute -bottom-8 left-1/2 -translate-x-1/2 flex items-center justify-center shadow-sm">
            <Heart className="w-7 h-7 text-white" fill="currentColor" />
          </div>
        ) : (
          <img src={fileUrl(profile.avatar_url) || `https://api.dicebear.com/7.x/lorelei/svg?seed=${profile.user_id}`}
            alt={profile.name} className="w-16 h-16 rounded-full object-cover object-center border-4 border-card bg-secondary absolute -bottom-8 left-1/2 -translate-x-1/2" />
        )}
      </div>
      <div className="pt-10 px-4 pb-4 flex-1 flex flex-col items-center">
        <Link to={`/u/${profile.user_id}`} className="font-serif font-semibold text-lg leading-tight hover:text-copper inline-flex items-center justify-center gap-1">
          {profile.name}
          {profile.verified && !profile.trusted && <VerifiedBadge size="sm" />}
        </Link>
        {(profile.protected || profile.trusted) && (
          <div className="flex flex-wrap justify-center gap-1 mt-1.5">
            {profile.trusted && <TrustedBadge />}
            {profile.protected && <UnderWingBadge />}
          </div>
        )}
        {profile.location && (
          <p className="text-xs text-muted-foreground flex items-center justify-center gap-1 mt-0.5"><MapPin className="w-3 h-3" /> {profile.location}</p>
        )}
        <p className="text-sm text-foreground/70 mt-2 line-clamp-3 flex-1">{profile.need || profile.story || profile.bio}</p>
        {profile.goal_enabled && profile.goal_amount > 0 && (
          <div className="w-full"><GoalThermometer raised={profile.goal_raised || 0} amount={profile.goal_amount} title={profile.goal_title} /></div>
        )}
        {profile.tags?.length > 0 && (
          <div className="flex flex-wrap justify-center gap-1 mt-3">
            {profile.tags.slice(0, 3).map((t) => (
              <span key={t} className="text-[10px] font-mono uppercase tracking-wide bg-secondary text-bronze px-2 py-0.5 rounded-full">#{t}</span>
            ))}
          </div>
        )}
        <div className="flex gap-2 mt-4 w-full">
          <Button data-testid="card-tip-btn" size="sm" onClick={() => onTip(profile)}
            className="flex-1 bg-copper hover:bg-copper/90 text-white rounded-full">
            <Heart className="w-3.5 h-3.5 mr-1" /> Tip
          </Button>
          <Link to={`/u/${profile.user_id}`} className="flex-1">
            <Button size="sm" variant="outline" className="w-full rounded-full border-copper/40 text-copper hover:bg-copper/10">
              <Eye className="w-3.5 h-3.5 mr-1" /> View
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
